import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c8931e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "get-in-touch",
  class: "get_in_touch_section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Reach me at:"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:oaikhenahjob@gmail.com",
    target: "_blank",
    rel: "noopener noreferrer",
    id: "my_email",
    "aria-describedby": "email"
  }, " oaikhenahjob@gmail.com "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "tel:+2348136767175",
    id: "my_phone",
    "aria-describedby": "phone"
  }, "+2348136767175")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Nice to meet you! If you want to keep in touch, send me a message using my email or phone details above, or use this form right here! Let's talk about software projects, tech, and all! You can also follow my online rants about Manchester United, the soccer team I support, although I highly discourage you spend your time with that activity. Anyway, you can hit me up on the social networks below: ", -1))
const _hoisted_4 = { "aria-describedby": "social links" }
const _hoisted_5 = ["aria-describedby"]
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  class: "contact__form",
  "aria-describedby": "contact form"
}
const _hoisted_8 = { class: "form__group" }
const _hoisted_9 = {
  key: 0,
  class: "error",
  for: "name"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Your name", -1))
const _hoisted_11 = { class: "form__group" }
const _hoisted_12 = {
  key: 0,
  class: "error",
  for: "email"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Your e-mail", -1))
const _hoisted_14 = { class: "form__group" }
const _hoisted_15 = {
  key: 0,
  class: "error",
  for: "email"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Your message", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Let's talk", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 80 80" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "8",
      y: "8",
      width: "64",
      height: "64"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_section_header = _resolveComponent("section-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_section_header, null, {
      default: _withCtx(() => [
        _createTextVNode("Get In Touch")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("article", null, [
        _hoisted_2,
        _createElementVNode("aside", null, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (social) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "social",
                key: social.name,
                "aria-describedby": social.name
              }, [
                _createVNode(_component_action_button, {
                  btnType: "link",
                  href: social.link,
                  class: "social_icon",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(social.name), 1),
                    _createVNode(_component_font_awesome_icon, {
                      icon: social.icon,
                      title: social.alt,
                      "aria-hidden": "true"
                    }, null, 8, ["icon", "title"])
                  ]),
                  _: 2
                }, 1032, ["href"])
              ], 8, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, [
            _createElementVNode("form", {
              id: "contact__form",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  id: "first_name",
                  name: "name",
                  required: "",
                  type: "text",
                  onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
                  class: _normalizeClass([_ctx.formError.name ? 'invalid' : '']),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sendData.name) = $event))
                }, null, 34), [
                  [_vModelText, _ctx.sendData.name]
                ]),
                (_ctx.formError.name)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_9, " This field is required "))
                  : _createCommentVNode("", true),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  name: "email",
                  required: "",
                  type: "email",
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
                  class: _normalizeClass([_ctx.formError.email ? 'invalid' : '']),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sendData.email) = $event))
                }, null, 34), [
                  [_vModelText, _ctx.sendData.email]
                ]),
                (_ctx.formError.email)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_12, " Please enter a valid email address "))
                  : _createCommentVNode("", true),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("textarea", {
                  rows: "4",
                  cols: "50",
                  id: "message",
                  name: "message",
                  onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
                  required: "",
                  class: _normalizeClass([_ctx.formError.message ? 'invalid' : '']),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sendData.message) = $event))
                }, null, 34), [
                  [_vModelText, _ctx.sendData.message]
                ]),
                (_ctx.formError.message)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_15, " This field is required "))
                  : _createCommentVNode("", true),
                _hoisted_16
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_action_button, {
                  btnType: "button",
                  type: "submit",
                  classType: "loader",
                  form: "contact__form",
                  className: _ctx.result.loading ? 'loading' : ''
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["className"])
              ]),
              _createElementVNode("output", {
                class: _normalizeClass([_ctx.output_class])
              }, _toDisplayString(_ctx.result.text), 3)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}